<!-- StepProduct.vue -->
<template>
  <div class="modal_product">
    <div class="modal_main_inputs_head" style="max-width: 70%;">
      Укажите конечный продукт и количество единиц в год
    </div>
    <!-- Продукт -->
    <div class="modal_product_result">
      <div class="modal_product_result_head">
        Продукт процесса <a href="#" @click.prevent>определен Lazarus AI</a>
      </div>
      <br>
      <div class="modal_product_result_content" 
           contenteditable="true"
           @blur="updateProduct"
           @keydown.enter.prevent
           ref="productField">
        {{ localProduct }}
      </div>
      <div class="modal_product_result_cup">
        Lazarus автоматически определил продукт на основе анализа регламента
      </div>
      <br><br>
    </div>

    <!-- Количество -->
    <div class="modal_product_result">
      <div class="modal_product_result_head">
        Количество единиц продукции в год
      </div>
      <br>
      <div class="modal_product_result_content" 
           contenteditable="true"
           @blur="updateQuantity"
           @keydown.enter.prevent
           @keydown="validateNumberInput"
           ref="quantityField">
        {{ localQuantity }}
      </div>
      <div class="modal_product_result_cup">
        Ожидаемое количество единиц продукции за год
      </div>
      <br><br>
    </div>

    <!-- Предварительная оценка (показываем после анализа) -->
    <div v-if="showEstimation" class="estimation-section">
      <div class="estimation-title">Предварительная оценка:</div>
      
      <div class="estimation-grid">
        <!-- Первая строка -->
        <div class="estimation-item">
          <div class="estimation-label">Стоимость одной единицы</div>
          <div class="estimation-value">{{ formatCost(estimation.cost_per_unit) }} ₽</div>
        </div>
        <div class="estimation-item">
          <div class="estimation-label">Время на единицу</div>
          <div class="estimation-value">{{ estimation.time_per_unit_hours }} ч</div>
        </div>
        
        <!-- Вторая строка -->
        <div class="estimation-item">
          <div class="estimation-label">Задействовано ролей</div>
          <div class="estimation-value">{{ estimation.total_roles_involved }}</div>
        </div>
        <div class="estimation-item">
          <div class="estimation-label">Годовой объем затрат</div>
          <div class="estimation-value">{{ formatCost(totalAnnualCost) }} ₽</div>
        </div>
      </div>
    </div>
    
    <!-- Кнопка -->
    <div class="modal_main_load_content_btn" 
         @click="handleClick"
         :class="{ 'loading': isLoading }"
         style="cursor: pointer; width: 100%; max-width: none;">
      <span v-if="isLoading">Анализируем...</span>
      <span v-else>{{ buttonText }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StepProduct',
  props: {
    product: {
      type: String,
      default: 'Утвержденный проектный план'
    },
    quantity: {
      type: [String, Number],
      default: '50'
    },
    estimation: {  // данные с бека
      type: Object,
      default: () => ({
        cost_per_unit: 0,
        time_per_unit_hours: 0,
        total_roles_involved: 0,
        total_annual_cost: 0,
        capacity_warning: false
      })
    },
    isLoading: {  // состояние загрузки
      type: Boolean,
      default: false
    },
    hasEstimation: {  // были ли уже получены данные
      type: Boolean,
      default: false
    }
  },
  emits: ['update:product', 'update:quantity', 'analyze', 'continue'],
  computed: {
    localProduct: {
      get() {
        return this.product
      },
      set(value) {
        this.$emit('update:product', value)
      }
    },
    localQuantity: {
      get() {
        return String(this.quantity)
      },
      set(value) {
        this.$emit('update:quantity', value)
        // Пересчитываем годовую стоимость при изменении количества
        this.$emit('update:quantity', value)
      }
    },
    showEstimation() {
    // Показываем если есть оценка И hasEstimation = true
    // Не проверяем cost_per_unit > 0, потому что может быть 0
    return this.hasEstimation && this.estimation && Object.keys(this.estimation).length > 0
  },
    totalAnnualCost() {
      // Пересчитываем годовую стоимость на основе количества
      const quantity = parseInt(this.quantity) || 0
      return this.estimation.cost_per_unit * quantity
    },
    buttonText() {
      return this.hasEstimation ? 'Продолжить' : 'Анализировать'
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.productField) {
        this.$refs.productField.innerText = this.localProduct
      }
      if (this.$refs.quantityField) {
        this.$refs.quantityField.innerText = this.localQuantity
      }
    })
  },
  methods: {
    updateProduct(event) {
      const value = event.target.innerText.trim()
      if (value) {
        this.localProduct = value
      } else {
        event.target.innerText = this.localProduct
      }
    },
    
    updateQuantity(event) {
      let value = event.target.innerText.replace(/\D/g, '')
      if (value) {
        value = value.replace(/^0+/, '')
        if (value === '') value = '0'
        this.localQuantity = value
        event.target.innerText = value
      } else {
        this.localQuantity = '0'
        event.target.innerText = '0'
      }
    },
    
    validateNumberInput(event) {
      const allowedKeys = [
        'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Tab'
      ]
      if (!/^\d$/.test(event.key) && !allowedKeys.includes(event.key)) {
        event.preventDefault()
      }
    },
    
    handleClick() {
      if (this.isLoading) return
      
      if (this.hasEstimation) {
        this.$emit('continue')
      } else {
        this.$emit('analyze')
      }
    },
    
    formatCost(value) {
      return new Intl.NumberFormat('ru-RU').format(value || 0)
    }
  },
  watch: {
    quantity() {
      // Обновляем отображение при изменении quantity извне
      if (this.$refs.quantityField) {
        this.$refs.quantityField.innerText = String(this.quantity)
      }
    }
  }
}
</script>

<style scoped>
.modal_product {
  position: relative;
  padding: 20px;
}

.modal_main_inputs_head {
  text-align: start;
  margin-bottom: 24px;
  font-size: 18px;
  line-height: 1.4;
}

.modal_product_result_head {
  text-align: start;
  color: #888;
  font-size: 14px;
  margin-bottom: 8px;
}

.modal_product_result_head a {
  color: #8A75FF;
  text-decoration: none;
}

.modal_product_result_head a:hover {
  text-decoration: underline;
}

.modal_product_result_content {
  background: #241F3E;
  border-radius: 20px;
  border: 1px solid #415B81;
  width: 100%;
  padding: 20px 30px;
  text-align: start;
  font-size: 18px;
  transition: border-color 0.3s;
  cursor: text;
}

.modal_product_result_content:focus {
  outline: none;
  border-color: #8A75FF;
}

.modal_product_result_cup {
  text-align: start;
  font-size: 0.8rem;
  padding-top: 8px;
  color: #666666;
}

.estimation-section {
  margin-top: 32px;
  padding: 24px;
  background: #ffffff0a;
  border: 1px solid #403F6D;
  border-radius: 16px;
}

.estimation-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 20px;
  color: #fff;
  margin-bottom: 32px;
  text-align: start;
}

.estimation-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
}

.estimation-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
}

.estimation-label {
  font-size: 14px;
  color: #888;
}

.estimation-value {
  font-size: 24px;
  font-weight: 600;
  color: #8A75FF;
}

.modal_main_load_content_btn {
  display: flex;
  gap: 8px;
  padding: 18px 40px;
  background: #8A75FF;
  justify-content: center;
  border-radius: 24px;
  cursor: pointer;
  transition: opacity 0.3s;
  margin-top: 24px;
  opacity: 1;
}

.modal_main_load_content_btn:hover {
  opacity: 0.9;
}

.modal_main_load_content_btn.loading {
  opacity: 0.7;
  cursor: not-allowed;
}

@media (max-width: 768px) {
  .estimation-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
}
</style>